import { defineComponent as _defineComponent } from 'vue';
import { MetricValueKind, MetricReportingPeriodType } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'MetricForm',
  props: {
    value: null,
    changes: null
  },
  emits: ['input'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var valueType = computed(function () {
      var _props$changes, _props$value;
      return (props === null || props === void 0 ? void 0 : (_props$changes = props.changes) === null || _props$changes === void 0 ? void 0 : _props$changes.valueType) || (props === null || props === void 0 ? void 0 : (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.valueType);
    });
    var currentValueOptions = computed(function () {
      var _props$changes2, _props$value2;
      return (props === null || props === void 0 ? void 0 : (_props$changes2 = props.changes) === null || _props$changes2 === void 0 ? void 0 : _props$changes2.valueOptions) || (props === null || props === void 0 ? void 0 : (_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.valueOptions) || {};
    });
    var defaultReportingPeriod = computed(function () {
      var _props$changes3, _props$value3;
      return (props === null || props === void 0 ? void 0 : (_props$changes3 = props.changes) === null || _props$changes3 === void 0 ? void 0 : _props$changes3.defaultReportingPeriodType) || (props === null || props === void 0 ? void 0 : (_props$value3 = props.value) === null || _props$value3 === void 0 ? void 0 : _props$value3.defaultReportingPeriodType) || MetricReportingPeriodType.Annual;
    });
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var units = computed(function () {
      return [{
        header: proxy.$t('units.createAUnit')
      }, proxy.$t('units.tonnesCO2'), proxy.$t('units.GWh'), proxy.$t('units.tonnes'), proxy.$t('units.EUR'), proxy.$t('units.USD'), proxy.$t('units.percent'), proxy.$t('units.number'), proxy.$t('units.yesNo'), proxy.$t('units.unitReference'), proxy.$t('units.category')];
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      valueType: valueType,
      currentValueOptions: currentValueOptions,
      defaultReportingPeriod: defaultReportingPeriod,
      proxy: proxy,
      units: units,
      MetricValueKind: MetricValueKind
    };
  }
});